<template>
  <rmp-base-modal
    v-model="isOpen"
    extra-classes="BorderedHeaderModal"
  >
    <template #modal-header>
      <h2 class="u-text-center">
        Video Embed Not Supported
      </h2>
    </template>
    <template #modal-body>
      <div>
        <h3>
          Video embed is not supported in the new layout and will be removed.
        </h3>
        <p>
          Are you sure you want to remove the video and change layouts?
        </p>
      </div>
    </template>
    <template #modal-footer>
      <div class="u-floatLeft">
        <button
          class="Button Button--green-outline"
          @click="isOpen = false"
        >
          Cancel
        </button>
      </div>
      <div class="u-floatRight">
        <button
          :class="[{'is-loading': ui.submitLoading }, 'Button Button--danger']"
          @click="handleDeleteVideoEmbed"
        >
          Remove Video
        </button>
      </div>
    </template>
  </rmp-base-modal>
</template>
<script>
import { mapMutations } from 'vuex';
import RmpBaseModal from '@rmpenterprise/base-modal';
import ModalActionsMixin from './mixins/modal-actions-mixin';

export default {
  components: { RmpBaseModal },
  mixins: [ModalActionsMixin],
  props: {
    question: {
      type: Object,
      default() {
        return {};
      },
    },
    layoutType: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      ui: {
        submitLoading: false,
      },
    };
  },
  methods: {
    ...mapMutations('forms', ['setScreenLayoutType', 'updateSelectedQuestion', 'resetSelectedQuestion']),
    handleDeleteVideoEmbed() {
      this.setScreenLayoutType(this.layoutType);
      this.updateSelectedQuestion({ ...this.question, layout: { type: 'text-only', video: null, videoSource: null } });
      this.resetSelectedQuestion();
      this.isOpen = false;
    },
  },
};
</script>
<style lang="less" scoped>
.BorderedHeaderModal {
  .Notice {
    margin-bottom: 25px;
  }
  .Form-field{
    margin-bottom: 0;
  }
}
</style>
